import template from './specialty-business.jade';
import validation from '../../../services/validation';

export default angular
  .module('cian.addForm.aboutObjectSpecialtyBusiness', ['cian.addForm.helperSpecialty'])
  .directive('cianAfAboutObjectSpecialtyBusiness', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      function () {
        this.validation = validation(this.form, 'specialty', {
          required: 'Обязательное поле',
        });
      },
    ],
    controllerAs: 'specialty',
    template,
  })).name;
